import React from 'react';
import styles from './Card.module.css';
import { transform } from 'typescript';
import { useLocation } from 'react-router-dom';

interface Card {
  aguardando: boolean | undefined;
  img: string | undefined;
  procedimento: string | undefined;
  data: string | undefined;
  medico: string | undefined;
  tipo: number | undefined;
  link: string | undefined;
  descricao: string | null;
  erro?: string; // 👈 nova prop
}

const Card = ({
  aguardando,
  img,
  procedimento,
  data,
  medico,
  tipo,
  link,
  descricao,
  erro, // 👈 recebendo o erro
}: Card) => {
  const location = useLocation();
  const [isHovering, setIsHovering] = React.useState(false);

  const handleMouseOver = () => setIsHovering(true);
  const handleMouseOut = () => setIsHovering(false);

  const estiloDoElemento = {
    background: aguardando ? '#ededed' : '#dedede',
    cursor: aguardando ? 'default' : 'pointer',
    transform: aguardando ? 'none' : '',
  };

  React.useEffect(() => {
    const element = document.querySelector('.animeLeft2') as HTMLElement;
    if (element) {
      element.classList?.remove('animeLeft2');
      void element.offsetWidth;
      element.classList?.add('animeLeft2');
    }
  }, [location.pathname]);

  if (erro) {
    return (
      <div className={`${styles.containerCard} ${styles.erroCard}`}>
        <div className={styles.logoCard}>
          <img src="/erro.svg" alt="Erro" />
          <p>Erro ao carregar dados</p>
        </div>
        <div className={styles.infosCard}>
          <p className={styles.mensagemErro}>{erro}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {aguardando ? (
        <div
          className={styles.containerCard}
          style={estiloDoElemento}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
        >
          <div className={styles.logoCard}>
            <img src={img} alt={`ícone do status do ${tipo}`} />
            {aguardando && <p>Aguardando Resultado</p>}
          </div>
          <div className={styles.infosCard}>
            <p>{descricao}</p>
            <p>{medico}</p>
            <p>{data}</p>
          </div>
        </div>
      ) : (
        <a href={link} target="_blank">
          <div className={styles.containerCard}>
            <div className={styles.logoCard}>
              <img src={img} alt={`ícone do status do ${tipo}`} />
              {aguardando && <p>Aguardando Resultado</p>}
            </div>
            <div className={styles.infosCard}>
              <p title={medico || ''} className={styles.truncate}>
                {medico}
              </p>
              <p
                title={data ? data.split('-').reverse().join('-') : ''}
                className={styles.truncate}
              >
                {data ? data.split('-').reverse().join('-') : ''}
              </p>
              <p title={descricao || ''} className={styles.truncate}>
                {descricao}
              </p>
            </div>
          </div>
        </a>
      )}
    </>
  );
};
export default Card;
